import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import DownloadAssetCard from "./DownloadAssetCard";
import DownloadMiscCard from "./DownloadMiscCard";
import "./MarketingMaterials.css";

export default function Index({ cart = true }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // validate user
  const { search } = useLocation(); // search is gonna be "/Home"
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl || "/Login";

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  useEffect(() => {
    if (!userInfo) {
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logged in ");
    }
  }, [dispatch, navigate, redirect, userInfo]);

  const assetCardData = [
    {
      title: "Maevn Brand Assets",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/MaevnBrandAssets.jpg",
      indicatorColor: "#04ADD1",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/xvy9i8ncx66qrer1t6rkm/AFWFzLrRZ1yCkG9WGmifeOI?rlkey=lzoznhq5wlpyfzz95nkqcc64p&st=w59yrgfo&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "https://www.dropbox.com/scl/fo/nlwjypj1iyqr0uo2l36jr/AKRD5kJVzZG7hBQxY_zrYmI?rlkey=cv8m8equ503soujhrjg7wcajd&st=tw9wx7od&dl=0",
        },
        {
          name: "Lifestyle Images",
          url: "",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/vlnw5mdq14y98htbwlf1n/AAq_dULX__rpOsCgtevkQFM?rlkey=xs7o0kmzlobo0yc6zs2vgkm4x&st=uuqjfxbu&dl=0",
        },
        {
          name: "Product Images",
          url: "",
        },
      ],
    },
    {
      title: "Momentum",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Momentum.jpg",
      indicatorColor: "#3DCF7A",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/oatkwczj8qtsqkadhqn47/h?rlkey=c7yubulh8mhzzwc6fs5hngo4s&st=ejbf0ylg&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "https://www.dropbox.com/scl/fo/721v6im1fefbi6kiqsh28/AL4ffLxhezl_jB9Z0c3l4bE?rlkey=hseg3qfdxfdntln84gry5xyq7&st=dwmgk5em&dl=0",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/v85pvvjckhgu79y8wcxsl/AILQ19giJcCSJ-RMlKTlMJs?rlkey=ib7lou4lchzazwf2r0rmxw1j5&st=zmd6ho0j&dl=0",
        },
        {
          name: "Line Drawings",
          url: "https://www.dropbox.com/scl/fo/tiyccrcfoeea586ccf0fm/AMUg848Yuic9fL2bPqLC3U0?rlkey=ol9dfyu34w53z643kt5byvvkd&st=mmqzn9v7&dl=0",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/30r6poeb0gs7v1cmbwdx1/AE91RXO0p8ELv5Fr61sj5rs?rlkey=x5aboxe31x81pq2i6f8rsr42h&st=k8seus0z&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/tqo5axjb88me5ykj1ca7t/AOK1Hq-gkK5PdYUpcPEns9w?rlkey=4am34guz2yfsm81t85a4jtz2m&st=a6kwkhw7&dl=0",
        },
      ],
    },
    {
      title: "Embrace",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Embrace.jpg",
      indicatorColor: "#9C90C2",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/j24bwmyvo5htue20oapbs/ANUDHLD307EZTW_1yJZfRkY?rlkey=n148icygobdhdnumxdyqlvw2c&st=xgkc847n&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "https://www.dropbox.com/scl/fo/4xcunewomz6tmt5lcaeew/AFiyWZXmzKe-0hwNmnNXUAs?rlkey=pnixjj025j8rcrf2mfu17u22l&st=ajumomqu&dl=0",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/zm02smcdcoku9d8dqni89/AP9psAe_n-mL6pglCXQcCdk?rlkey=a1vjsde6s0m4u10dljoweiotk&st=p29umasu&dl=0",
        },
        {
          name: "Line Drawings",
          url: "https://www.dropbox.com/scl/fo/44q3vzg7t0k67lk5uc817/AN6IhjCVQedVx8xe7NKWjHY?rlkey=8xqq47ex5eou27220lh6m4wcs&st=enli4d84&dl=0",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/sr4me0d6841slybg7g8ge/APqNST4wbJSSOGc2OqRlwEA?rlkey=hs8rcipaub7431vx3za1p47mh&st=87y6frqx&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/1mg1gbo2ui2mkvk4ed6p9/AM4bLOhIBx4aV0-YCZBJxBM?rlkey=peey7h9nxbcnmj0zgqtyhcjba&st=88m1wxaa&dl=0",
        },
      ],
    },
    {
      title: "Focus",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Focus.jpg",
      indicatorColor: "#CF3D67",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/v2awdmul4m9ek3ub2nt8a/h?rlkey=sedvf976v8qik6gilbq77azaw&st=uzs4fp4g&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "https://www.dropbox.com/scl/fo/9lyqk5t367mr2bixell69/AAm0VpYoqLvnmySfVCxJb1g?rlkey=3gdpq9vutbwm1t216jr8fen74&st=u0tf2rkj&dl=0",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/2zpcoqmk5yywq6pq64j90/ABbfD18WlJWHGzw6U7318PY?rlkey=l25ulimn0dmgk23ryddj0gel4&st=3nsvtnpk&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/o4myocl4vvfn7tz55id9c/ALJsHEa8C0RewEYgci-jnRM?rlkey=c6yikv9bglpmfmrk604k4t8nc&st=9196hb0j&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/mhesauw1miuiuxler9xnd/AAg3AmudwO4P9ipZ9KTUIEo?rlkey=jfk5wcxb7iks3gy51k4w7zaxi&st=yhehw1e1&dl=0",
        },
      ],
    },
    {
      title: "Lab Coats",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/LabCoats.jpg",
      indicatorColor: "#3E7BB7",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/s2lfs90c7eebnrtp44z13/ADKl4UmcZuLuEN3DRK4Z2Po?rlkey=y8ctukanr08jf3flixeobwxtx&st=ib4xlv8e&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/dlvxkd2fwzr4pzff513cg/ABI7NWfGQwqTEtYwigwRcIs?rlkey=xfkm0b32y0krdu183qfx0iqtl&st=6zzlmqo4&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/q3uwv9pn31fuvh4a4839q/AIFDt-LoPVUeuFxTH7VZsyM?rlkey=ymtfmafozqjf9uytjaqmrai87&st=8hkksvkp&dl=0",
        },
      ],
    },
    {
      title: "Blaze",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Blaze.jpg",
      indicatorColor: "#3E5CB7",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/0vvj8b7k21nlixu37uylp/ALgr3WDZVcc-9rAoNJse4jY?rlkey=2733ruq2406aizq1pd1qmlmp5&st=qcnqclwh&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/0vvj8b7k21nlixu37uylp/AExfOLgRuKQPiTS2NEz3JdE/Lifestyle%20Images?dl=0&rlkey=2733ruq2406aizq1pd1qmlmp5&subfolder_nav_tracking=1",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/0vvj8b7k21nlixu37uylp/AJTIWd9hbEtZ0ZV6fZK1HRM/Product%20Images?dl=0&rlkey=2733ruq2406aizq1pd1qmlmp5&subfolder_nav_tracking=1",
        },
      ],
    },
    {
      title: "Blaze Lite",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/BlazeLite.jpg",
      indicatorColor: "#a5a6a7",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/f1s05kvj1dm597r633wwj/ALCf_R76TUtpoWgNbaO_9-A?rlkey=6ht71n0yujgkm3mcpd9os9rvd&st=o3pra30n&dl=0",
      dropboxLinks: [
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/45d09i2dfpxv7abwgb398/AEeScxXU1I9bBAyPj9Hq_EI?rlkey=0im0470fjlbu2pqcqiffnxglp&st=fhu3toxu&dl=0",
        },
      ],
    },
    {
      title: "Ease Loungewear",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/EaseLoungewear.jpg",
      indicatorColor: "#c6929e",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/hlltkbnuxjxbqqssdf4me/ALbp-JUwriYDocoec2V2ZgA?rlkey=ph3qzvhv8u1bxqhbqcbjcmv9w&st=9lqlp4co&dl=0",
      dropboxLinks: [
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/1oo4w4bbk33yn5gs1ngi0/ANFR5KZ2sTOgHks9OB-zxiA?rlkey=hcotk3e8qfhxq04n249o3tq9m&st=y37jt4nw&dl=0",
        },
      ],
    },
    {
      title: "Bestee",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Bestee.jpg",
      indicatorColor: "#EA5DB4",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/t682aua0y47vlroympbt8/ALnG7BJLoPP063xfJ6GdcP8?rlkey=jscanp5qx337ixxqrdtiiausu&st=ijkqx29v&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/7ikjxljopysk3leljmd76/AF6n1LKJZEKpx_eDuecFvx4?rlkey=2ojsuf6i67jj5wyqfzfxx7cqx&st=te4qhttu&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/pd3wr52rv0vpdyuaqjvhi/ABoQpdnkj_Z8ijp9lNwzcng?rlkey=hfq8f6qj5sxl24o3qwqgfougs&st=57d8d7ao&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/2oqkqqfpfshwchgxbwgmn/AL0DxFAIyQtyBrXk04Zz2LY?rlkey=dv0z2mrad95wiyajpyw574n0p&st=ri8zrsfk&dl=0",
        },
      ],
    },
    {
      title: "Prints",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Prints.jpg",
      indicatorColor: "#C61F89",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/cqlqbpb59f6to00in2h63/AF8Thup20l0BID4zgJLNFpw?rlkey=cpgqmejqo9fljzkc5vdm8a6sv&st=1xjfy6dk&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/09ppgwxfpm12prcf68o6j/AJzzLe8l5DkIGoiKScTwyW4?rlkey=i38hn2183mfdy9vmbpuwffzol&st=9inyh4li&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/lchl10imo171n3riwc61k/ABIP-0pGFSv63cBxT4pQrcE?rlkey=osv37k3kkscbjtqqoflmxonqs&st=tllqmi3r&dl=0",
        },
      ],
    },
    {
      title: "ReadyGo",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/ReadyGo.jpg",
      indicatorColor: "#E6521C",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/ykxcwq1a0rqqs2zgdt8a8/AENIc6c62O1sb4xvSjt8Kjg?rlkey=59p29o149lu542ofkypq34ubc&st=r7183061&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/q8fbnahs4n9qf8qvdyy6o/AJ-gyYEAyz1rXtrlurv5WAg?rlkey=l770brxmur2f1ouzjjw6wbo9v&st=eba72ap5&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/uic610cte6b38ipxw9l41/AKu8_H3AlTYanr7AcWuzxKo?rlkey=mgby01fq8s9k174j5vtm8efq6&st=792nnb2j&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/9xr8gf48jc4xk2nsi0lvh/ADKsI-Lu7Yan5EoM7U2OcVU?rlkey=hy1hspt9pcigwfeavpry3nwbu&st=ycycbjeh&dl=0",
        },
      ],
    },
    {
      title: "Matrix",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/Matrix.jpg",
      indicatorColor: "#C5DB81",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/t78hh5js24ajl5ifwaaj1/AIwHTkw7qj4r6n1PjURHIFU?rlkey=yg96ew9dn4sq6a54q9b1wfy2q&st=shphqqzf&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/ixc82vz9bwxffdnjplfdt/AAuSo9Qfhe41gAE-YENqVzI?rlkey=glhwm0lgqa24k0xvke1jjqpkq&st=qt5vzqad&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/2ba1j5i0dtqqnvn97u261/ANCfRSuDNyGxNL01DQeIy20?rlkey=oww35f07iyru3p3080pyeknqa&st=3ntzs18y&dl=0",
        },
      ],
    },
    {
      title: "Matrix Impulse",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/MatrixImpulse.jpg",
      indicatorColor: "#E7A7BB",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/fnh0mgncnsy4ssg180551/ABDZB7S8heREMBfyJGago9A?rlkey=y6ta4kw2wc3h2iuz2lkwmj8xu&st=p4u2p35z&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "https://www.dropbox.com/scl/fo/5ndt7n182pwahuwv4jvl0/AA-1hQSUq-FQ00tvF6tpBrU?rlkey=g7l0u0ukjtj1fh7m3gixbdn4a&st=568ox2c7&dl=0",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/itt7wyvzvbw9d43kfu97d/AFQ4uByPEmfKq6mdyThsu-0?rlkey=xd86w5qquq22fdeioebb1syec&st=5oxaejjb&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "https://www.dropbox.com/scl/fo/rsacwyi96teymmrp81ds3/APTP0LRXOHnLrDWNBukXrFc?rlkey=cbwppuv1a7np5hj1o0pfv9jto&st=xxtjn7jb&dl=0",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/4kc1w62wqf8ljbf4ejfc0/ADn3zjVPU8hfQnoMyQdQtAA?rlkey=jy0y4xex8o49cwi0nx88nqdo3&st=b6cemino&dl=0",
        },
      ],
    },
    {
      title: "Matrix Pro",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/MatrixPro.jpg",
      indicatorColor: "#C9B23D",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/bnmj2h4m4qsb41yyxj19i/h?rlkey=o84mqnjnmd61ll6amgkzh5j6i&st=q8sbo1cr&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/3ctojl7rettrbn1bd798y/ADFNZOOPea3DPg11ClYuTl0?rlkey=naboho3yqpg045rglarmu8raf&st=cwa3myn6&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        { name: "Logos", url: "" },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/zhzlpv5cprgcu31r42o3g/h?rlkey=lktwvao8uve9guv8zt8x57vup&st=qg2w3kl5&dl=0",
        },
      ],
    },
    {
      title: "Red Panda",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/RedPanda.jpg",
      indicatorColor: "#CF473D",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/7i6tqgqae99o7g7ck7mf7/ACwZLxL30SBcvCoOhEgjna4?rlkey=fdu3sn2f2pzkjnn88x87xdvem&st=amwodbdr&dl=0",
      dropboxLinks: [
        {
          name: "Digital & Print Marketing Assets",
          url: "",
        },
        {
          name: "Lifestyle Images",
          url: "https://www.dropbox.com/scl/fo/zmr8s6lq4wosef2qnmqvn/ADW15IvcmMo94Wgpk5yUJUI?rlkey=aspanzcrw7a704mwoqosz1tkg&st=ynbu4f6i&dl=0",
        },
        {
          name: "Line Drawings",
          url: "",
        },
        {
          name: "Logos",
          url: "",
        },
        {
          name: "Product Images",
          url: "https://www.dropbox.com/scl/fo/44ta4s08rp5b057qlmjo7/AGdJzr0hv6zEfHZ1AtVdIUw?rlkey=m3lalpjyuy1iysdlqlddgkoeu&st=zpl23jz6&dl=0",
        },
      ],
    },
    {
      title: "Social Media Assets",
      imageSrc:
        "https://maevn-images.s3.us-east-2.amazonaws.com/MarketingMaterials/SocialMediaAssets.jpg",
      indicatorColor: "#CD68DF",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/5wj5zsvxcej3xxpwyzcka/AHve8lyB9ve6z641rP3taF0?rlkey=xb1lppro7au4334h9ohi1tqmw&st=phukm8oe&dl=0",
      dropboxLinks: [
        {
          name: "Collections",
          url: "https://www.dropbox.com/scl/fo/4yyr7hpjilc46rftp0sto/AAsgIwsrJie2bXihMCtsZgY?rlkey=g96b66k96puagk0buw6fetkot&st=jvxlrxtc&dl=0",
        },
        {
          name: "Video",
          url: "https://www.dropbox.com/scl/fo/fkddis3t1qko2kq0rb42v/AEWCp2ucqIwKG6mWp9PyAkI?rlkey=jkpvghizmzu3so540draq3tgr&st=gwh5g1js&dl=0",
        },
      ],
    },
  ];

  const miscCardData = [
    {
      title: "Color Swatches",
      gradientColors: ["#FFD284", "#FF97DE"],
      borderTopColor: "#FFD284",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/zp8vnstfeee58rgmmq4eh/AHbxG-hyXnlkjjDywwjlr7Q?rlkey=bbq74aln7kqghrir0gzha5q90&st=imxcatke&dl=0",
    },
    {
      title: "Sizing Guide",
      gradientColors: ["#95E4E7", "#ACBBFF"],
      borderTopColor: "#ACBBFF",
      allInOneLink:
        "https://www.dropbox.com/scl/fo/ylachau4wp1aqz5pfrdyu/AIskYY9nCU3TeOYjTAbrWYw?rlkey=2jv45rfhsne9id2zfm0guhp1w&st=42z94rsz&dl=0",
    },
  ];

  return (
    <Layout childrenClasses={`${cart ? "pt-0 pb-0" : ""} relative`}>
      <div className="cart-page-wrapper w-full white-background">
        <div className="w-full bg-white pb-[100px]">
          {/* Page history */}
          <PageTitle
            title="Marketing Materials"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Marketing Materials", path: "/MarketingMaterials" },
            ]}
          />
          <div className="container-x mx-auto">
            <div className="download-assets-title">
              Download Assets by Collections
            </div>
            <div className="download-assets-subtitle">
              Easily access and download images, logos, and other marketing
              assets for each collection.
            </div>

            <div className="download-assets-grid mx-auto">
              {assetCardData.map((card, index) => {
                const shouldHide =
                  userInfo?.result?.user?.userId === 559 &&
                  userInfo?.result?.user?.loginId === "UNIM10FL" &&
                  card.title === "Embrace";

                if (shouldHide) return null;

                return (
                  <DownloadAssetCard
                    key={index}
                    title={card.title}
                    imageSrc={card.imageSrc}
                    indicatorColor={card.indicatorColor}
                    allInOneLink={card.allInOneLink}
                    dropboxLinks={card.dropboxLinks}
                  />
                );
              })}

              {/* {assetCardData.map((card, index) => (
                <DownloadAssetCard
                  key={index}
                  title={card.title}
                  imageSrc={card.imageSrc}
                  indicatorColor={card.indicatorColor}
                  allInOneLink={card.allInOneLink}
                  dropboxLinks={card.dropboxLinks}
                />
              ))} */}
            </div>
            <div className="download-assets-title">Additional Assets</div>
            <div className="download-assets-subtitle">
              Download color swatches and sizing guides to help customers find
              their perfect color and fit.
            </div>

            <div className="download-misc-grid mx-auto">
              {miscCardData.map((card, index) => (
                <DownloadMiscCard
                  key={index}
                  title={card.title}
                  gradientColors={card.gradientColors}
                  borderTopColor={card.borderTopColor}
                  allInOneLink={card.allInOneLink}
                />
              ))}
            </div>
          </div>{" "}
        </div>
      </div>
    </Layout>
  );
}
